export const userIsKrinoAction = (isKrino) => ({
  type: '@user/krinoClient',
  isKrino
})